import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiArchive, FiUpload } from 'react-icons/fi';

export const MenuItemArchiveCourse = (props: {
  course: ICourse;
  onArchiveCourse: (course: ICourse) => void;
}) => {
  const isArchived = props.course.archived;
  
  return (
    <MenuItem 
      icon={isArchived ? <FiUpload /> : <FiArchive />} 
      onClick={() => props.onArchiveCourse(props.course)}
    >
      {isArchived ? 'Unarchive Course' : 'Archive Course'}
    </MenuItem>
  );
}
